import styled from "styled-components"

export const Container = styled.div``
export const Fields = styled.div``
export const Footer = styled.footer``
